import { Languages, Snowflake, GlassWater, Wifi, BatteryCharging } from "lucide-react";
import { ASSETS } from "@/data/site";

const services = [
  { icon: Languages, title: "English-speaking drivers", testid: "service-english-drivers" },
  { icon: Snowflake, title: "Air conditioning", testid: "service-air-conditioning" },
  { icon: GlassWater, title: "Complimentary water", testid: "service-water" },
  { icon: Wifi, title: "Free on-board Wi-Fi", testid: "service-wifi" },
  { icon: BatteryCharging, title: "Phone chargers", testid: "service-chargers" },
];

const Features = () => {
  return (
    <section id="services" className="section relative grain">
      <div className="max-w-6xl mx-auto px-5 lg:px-10 text-center">
        <h2 className="font-display text-4xl md:text-5xl leading-[1.05]">
          Our
          <span className="text-gold italic"> services.</span>
        </h2>

        <div
          data-testid="services-grid"
          className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 text-left"
        >
          {services.map(({ icon: Icon, title, testid }) => (
            <div
              key={title}
              data-testid={testid}
              className="glass rounded-2xl p-6 flex items-center gap-4 transition-colors hover:border-gold/40"
            >
              <div className="inline-flex items-center justify-center h-11 w-11 rounded-full bg-gold/15 text-gold shrink-0">
                <Icon className="h-5 w-5" />
              </div>
              <h3 className="font-display text-lg md:text-xl text-foreground">
                {title}
              </h3>
            </div>
          ))}
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          <div className="rounded-[2rem] overflow-hidden shadow-2xl shadow-[#0a1830]/40 bg-[#0a1830]">
            <img
              src={ASSETS.ourTaxi}
              alt="Our yellow Toyota Hybrid taxi at night"
              className="w-full h-full max-h-[420px] object-contain"
              loading="lazy"
              data-testid="img-our-taxi"
            />
          </div>
          <div className="rounded-[2rem] overflow-hidden shadow-2xl shadow-[#0a1830]/40 bg-[#0a1830]">
            <img
              src={ASSETS.ourTaxi3}
              alt="Our yellow Athens taxi at night"
              className="w-full h-full max-h-[420px] object-contain"
              loading="lazy"
              data-testid="img-our-taxi-3"
            />
          </div>
          <div className="rounded-[2rem] overflow-hidden shadow-2xl shadow-[#0a1830]/40 bg-[#0a1830]">
            <img
              src={ASSETS.ourTaxi2}
              alt="Our yellow Skoda Kodiaq SUV taxi from the fleet"
              className="w-full h-full max-h-[420px] object-contain"
              loading="lazy"
              data-testid="img-our-taxi-2"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
